import DeleteAccount from "./components/DeleteAccount/DeleteAccount";

function App() {
  return <DeleteAccount />;
}

export default App;